import { useState } from "react";
import { useNavigate } from "react-router-dom";

import demoImage from "../../../assets/demoImages/demoImage.jpg";
import tapIcon from "../../../assets/Icons/tap_icon.png"
import Preview from "./preview";
import { postLogDetails } from "../../../Services/APIs/appDetails";

const DemoScreens = (props) => {
    const company = localStorage.getItem("company");
    const uid = JSON.parse(localStorage.getItem("usertpi" || "{}")).usertpi
    const { activeImageSide, setToothPicker, setDemo, setCamera, quickScan } =
        props;
    const [selectedImage, setSelectedImage] = useState(null);
    const [showPreview, setShowPreview] = useState(false);

    const gotIt = () => {
        setDemo(false);
        setCamera(true);
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
            if (validTypes.includes(file.type)) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    postLogDetails({ app: company, payLoad: "previewing the phooto", uid })
                    setSelectedImage(e.target.result);
                    setShowPreview(true);
                };
                reader.readAsDataURL(file);
            } else {
                alert('Please select a valid image file (JPEG, JPG, or PNG)');
            }
        }
    };


    const handleClosePreview = () => {
        setShowPreview(false);
        setSelectedImage(null);
        const input = document.getElementById('imageUploadInput');
        if (input) {
            input.value = '';
        }
    };

    return (
        <>
            {
                <div className="bg-[#F6F6F6] h-full w-full ">
                    <div className=" h-3/5 w-full pt-4 px-4 bg-[#F6F6F6] ">
                        <img src={demoImage} alt="ai-teeth" className="h-full w-full object-contain  " />
                    </div>
                    <div className="h-2/5  bg-[#F6F6F6] ">
                        <div className=" h-full w-full flex flex-col justify-around px-8">
                            <div className=" font-jost text-base font-normal text-[#022022] md:text-3xl  text-center px-10  flex-grow py-4">Align your head inside the circle, flash that big smile</div>


                        {
                            company === "smileverse" ?
                            <div className="flex flex-col place-items-center gap-4 mb-4">
                                <button className="min-w-full universal-button text-white p-3 text-base md:text-3xl md:h-16 md:min-w-[30rem] max-w-[30rem]" onClick={gotIt}>Take selfie</button>
                                <input
                                    id="imageUploadInput"
                                    type="file"
                                    onChange={handleFileChange}
                                    accept="image/jpeg, image/jpg, image/png"
                                    style={{ display: 'none' }}

                                />
                                <button 
                                    className="min-w-full universal-button text-white p-3 text-base md:text-3xl md:h-16 md:min-w-[30rem] max-w-[30rem]"
                                    onClick={() => {
                                        postLogDetails({ app: company, payLoad: "clicked upload photo", uid  })
                                        document.getElementById('imageUploadInput').click()

                                    }}
                                >
                                    Upload photo
                                </button>
                                
                            </div> :
                        

                            <div className="  text-center py-8">
                                <button
                                    type="button"
                                    className="font-jost  font-medium text-[#022022] border border-[#022022] px-5 rounded-full	py-2 "
                                    onClick={() => {
                                        gotIt()
                                    }}
                                >
                                    GOT IT
                                </button>
                            </div>
                        }


                        </div>
                    </div>
                </div>
            }
            {showPreview && selectedImage && (
                <div className="fixed inset-0 bg-white flex items-center justify-center z-50">
                    <div className="relative w-full h-full">
                        <Preview 
                            image={selectedImage} 
                            setImageSide={() => {}}
                            setCamera={() => handleClosePreview()} 
                            onClose={handleClosePreview}
                            setDemo={handleClosePreview}
                            isFileUpload={true}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default DemoScreens;